import React from 'react';
import { Icon, Button, Div, Label, Modal, Checkbox } from '@pinpoint/design-kit';

/* eslint-disable react/prop-types */

export default function BetaProgramPopup({ isOpen, onClose, align, onClick, onBlock, content, okText, cancelText }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} align={align} rounded="md">
      <Icon name="Cross" pos="absolute" top="1rem" right="1rem" size="16px" onClick={onClose} cursor="pointer" />
      {content}
      <Label align="center" m={{ b: '0.5rem' }}>
        <Checkbox
          onClick={() => {
            onBlock();
          }}
          m={{ r: '0.5rem' }}
        />{' '}
        Do not show this message again
      </Label>
      <Div d="flex" justify="flex-end">
        <Button onClick={onClose} bg="gray200" textColor="medium" m={{ r: '1rem' }}>
          {cancelText}
        </Button>
        <Button
          onClick={() => {
            onBlock();
            onClose();
            onClick();
          }}
          bg="brand500"
        >
          {okText}
        </Button>
      </Div>
    </Modal>
  );
}
